import { render } from "./list.vue?vue&type=template&id=274afead"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=274afead&lang=scss"
script.render = render

export default script